import { render, staticRenderFns } from "./MyPhotos.vue?vue&type=template&id=252aaa46&"
import script from "./MyPhotos.vue?vue&type=script&lang=ts&"
export * from "./MyPhotos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports